module.exports = __webpack_public_path__ + "static/Instrucciones-73c4b28ae2acd26f20e9ff816115a707.png";